module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-6-380-6bb696085e9edc072faee170300dcc22.png";